import SideBar from '@/components/side_bar/SideBar.vue';
import ReferenceContent from '@/components/reference_content/ReferenceContent.vue';

export default {
  data: function() {
    return {};
  },
  components: {
    SideBar,
    ReferenceContent
  }
};
